export function authErrorKey(code: string): string {
  switch (code) {
    case "auth/invalid-credential":
    case "auth/wrong-password":
    case "auth/user-not-found":
      return "auth.errors.invalidCredential";
    case "auth/email-already-in-use":
      return "auth.errors.emailAlreadyInUse";
    case "auth/weak-password":
      return "auth.errors.weakPassword";
    case "auth/invalid-email":
      return "auth.errors.invalidEmail";
    case "auth/too-many-requests":
      return "auth.errors.tooManyRequests";
    case "auth/requires-recent-login":
      return "auth.errors.requiresRecentLogin";
    case "auth/expired-action-code":
      return "auth.errors.expiredActionCode";
    case "auth/invalid-action-code":
      return "auth.errors.invalidActionCode";
    case "auth/user-disabled":
      return "auth.errors.userDisabled";
    default:
      return "auth.errors.generic";
  }
}
